<template>
<div class="main">
	<Steps :index="0" product-name="物流特种设备三者责任险投保平台" />
	<Applicant :info="info" :amount="amount" :companyData="companyData" ref="applicant"/>
	<Recognize ref="recognize" :info="info" @set-amount="setAmount"/>
	<div class="mt20 center">
        <p class="agree">保费合计：<span class="price">{{amount}}元</span></p>
        <p class="mt10">
            <Button type="primary" @click="sub" :loading="loading">立即投保</Button>
        </p>
    </div>
	<TrackNotice v-if="id&&$route.query.reset" />
</div>
</template>
<script>
import Steps from './common/steps'
import Recognize from './recognize'
import Applicant from './common/applicant'
import TrackNotice from '@/components/common/TrackNotice.vue';
import { mapState } from 'vuex'
import track from "@/mixin/track";
export default {
	mixins:[track],
	components:{ 
		Steps,
		Recognize,
		Applicant,
		TrackNotice
	},
	data () {
		return {
			info:{
				policyTimeType:"1"
			},
			amount: null,
			loading:false,
			id:this.$route.params.id,
			companyData:[]
		}
	},
	computed:{
		...mapState({
			userInfo:state=>state.common.info
		})
	},
	watch:{
		userInfo(){
			this.checkLogin()
		}
	},
	created () {
		this.getUserInfo();
		if(this.checkLogin&&this.id){
			this.getInfo()
		}
	},
	mounted(){
		// 重新投保
		if(this.id&&this.$route.query.reset){
			this.track_is_new = true;
			this.$nextTick(()=>{
				this.trackInit();
			})
		} else {
			// 回溯 开始录制
			this.$nextTick(this.startRecord);
		}
	},
	methods:{
		async getUserInfo(){
			await this.$axios.post('/specialEquipment/centerUser/list.json',{
				phone: this.userInfo.phone,
				isDelete: 0 
			}).then((res) => {
				if(res&&res.length>0){
					this.companyData = res;
					this.info = {
						centerId:res[0].id,
						centerName:res[0].name,
						centerUserName:res[0].userName,
						phone:res[0].phone,
						companyListString:res[0].company,
					};
				} else {
					this.$Modal.error({
						title: '提示',
						content: '投保身份验证失败，您无法投保本产品，请联系业务人员处理后重试。'
					});
				}
			})
		},
		getPremium(){
			this.$refs.recognize.getPremium();
		},
		checkLogin(){
			// 检测登录
			if(!this.userInfo.userId){
				if(location.href&&location.href.indexOf('/common.html#/login')==-1){
					window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
				}
				return false
			}else{
				return true
			}
		},
		// 根据id获取信息
		getInfo(){
			this.$axios.post('/specialEquipment/insurance/detail.json',{
				billNo: this.id
			}).then(res=>{
				if(res.beginDate){
					// 续保
					res.beginDate='';
					res.endDate='';
					this.$refs.recognize.setStartTimeOption()
				}
				this.info = {
					...this.info,
					...res
				};
				this.$forceUpdate()
			});
		},
		// 校验
		async sub () {
			let applicant = await this.$refs.applicant.val();
			let recognize = await this.$refs.recognize.val();
			if(!applicant){
			    this.toast('投保信息校验失败','error');
			    return;
			}
			if(!recognize){
				return;
			}
			this.loading = true;
			if(this.$route.query.reset){
				recognize.detailList.forEach((item)=>{ 
					if (item.id){   
						delete  item.id;  
					}
				})
			}
			let form = {}
			form = {
				amount:applicant.amount,
				centerName:applicant.centerName + (applicant.centerName1?(','+applicant.centerName1):''),
				centerUserName:applicant.centerUserName,
				companyListString:applicant.companyListString,
				phone:applicant.phone,
				centerId: applicant.centerId,
				billType:1,
				companyListString: applicant.companyList.map(item=>item.value).join('、'),
				...recognize.employerTotalAmountVO,
				detailList:recognize.detailList
			}
			// if(this.id){
			// 	form.id = applicant.id;
			// 	form.billNo = this.id;
			// 	form.createTime = applicant.createTime;
			// }
			delete form.companyList;
		    this.$axios.post('/specialEquipment/insurance/save.json.all',form).then(async res=>{
				this.loading = false;
				if(res.code==10000000){
					// 回溯 停止录制
					await this.stopRecord({
						session_key:sessionStorage.track_session_key,
						policy_id:res.data
					});if(!this.id||res.data!=this.id){
						this.$router.push(`/forklift/fillin/${res.data}`)
					}
					this.$router.push('/forklift/confirm/'+res.data);
				}else{
		            this.alert(res.msg)
		        }
			}).catch(err=>{
				this.loading = false;
			});
		},
		// 设置总费用
		setAmount(amount) {
			this.amount=amount;
		}
	}
}
</script>
<style scoped lang="less">
	.draft{
		font-size: 18px;
		font-weight: bold;
	}
	.main{
		margin-top: 24px;
		padding :30px 40px;
	}
	.mt20{
	    // font-size: 25px;
	    line-height: 1.8;
	}
	span.price{
	    color:#FF0000;
	    font-weight: bold;
	}
	.text{
		font-size: 16px;
		color: red;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/forklift/fillin.vue